import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from '../i18n';
import { Globe, ChevronDown } from 'lucide-react';

const LanguageSelector = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const langCode = (i18n.language || 'en').split('-')[0];
  const currentLang = languages.find(l => l.code === langCode) || languages[1];

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-3 py-2 rounded-sm transition-colors ${
          variant === 'navbar'
            ? 'text-muted-foreground hover:text-white hover:bg-white/5'
            : 'bg-card border border-border hover:bg-accent'
        }`}
      >
        <Globe className="w-4 h-4" />
        <span className="text-sm">{currentLang.flag} {currentLang.code.toUpperCase()}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-card border border-border rounded-sm shadow-lg z-50 py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full flex items-center gap-3 px-4 py-2 text-sm transition-colors hover:bg-accent ${
                  i18n.language === lang.code ? 'text-primary bg-primary/10' : 'text-foreground'
                }`}
              >
                <span className="text-lg">{lang.flag}</span>
                <span>{lang.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
